import { Icon } from '../Icon.js'
import { EcoMark } from '../eco/EcoAvatar.js'
import { Spinner } from '../ui.js'

/** Said above anything the Assistant wrote, until it is undone or sent. */
export function DraftedBanner({
  writing,
  drafted,
  onUndo,
  onRedo,
}: {
  writing: boolean
  drafted: boolean
  onUndo: () => void
  onRedo: () => void
}) {
  if (!writing && !drafted) return null
  return (
    <div
      role="status"
      className="flex items-center gap-2 rounded-lg border-l-[3px] border-brand-500 bg-ink-50 px-3 py-2 text-[13px] text-ink-800"
    >
      {writing ? <Spinner tone="brand" className="size-4" /> : <EcoMark className="size-5" />}
      <span className="min-w-0 flex-1">
        {writing ? 'The Assistant is writing…' : 'Drafted by the Assistant. Read it before you send.'}
      </span>
      {drafted && !writing ? (
        <span className="flex shrink-0 items-center gap-3 font-semibold text-ink-900">
          <button type="button" className="hover:underline" onClick={onUndo}>
            Undo
          </button>
          <button type="button" className="hover:underline" onClick={onRedo}>
            Redo draft
          </button>
        </span>
      ) : null}
    </div>
  )
}

/** A template field with nothing behind it, left in the words as `[quote number]`. */
export function MissingFields({ missing, onDismiss }: { missing: string[]; onDismiss: () => void }) {
  if (missing.length === 0) return null
  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-lg border-l-[3px] border-ink-900 bg-ink-50 px-3 py-2 text-[13px] text-ink-800"
    >
      <Icon name="alert" className="mt-0.5 size-3.5 shrink-0 text-ink-900" />
      <span className="min-w-0 flex-1">
        {missing.length === 1 ? 'One field had' : `${missing.length} fields had`} nothing to fill it:{' '}
        {missing.map((label) => `[${label}]`).join(', ')}. Fill {missing.length === 1 ? 'it' : 'them'} in before you send.
      </span>
      <button type="button" aria-label="Dismiss" className="shrink-0 text-ink-500 hover:text-ink-900" onClick={onDismiss}>
        <Icon name="close" className="size-3.5" />
      </button>
    </div>
  )
}
